





































































import { Component, Mixins, Inject } from "vue-property-decorator";
import Context from "@/mixins/context";

// Types
import {
  IContractProductProvider,
  IContractProductProviderMethods
} from "@/models/providers/contractProduct";

@Component
export default class CProdCancellationRequest extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => IContractProductProvider;

  public get cProdData() {
    return this.$cProdData();
  }

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: IContractProductProviderMethods;

  // Computed

  public get reason() {
    return this.$_.get(this.cProdData.cancellationRequest, "reason", "")
      .trim()
      .replace(/[^a-zA-Z\d]$/, "");
  }
}
